import { Action, createReducer, on } from '@ngrx/store';
import { FavoriteCollection } from './collections.models';
import * as CollectionsActions from './collections.actions';

export const COLLECTIONS_FEATURE_KEY = 'collections';

export interface CollectionsState {
  collections: FavoriteCollection[];
  /** Number of all bookmarked documents, null as long as the backend does not deliver it */
  bookmarkCount: number | null;
  loaded: boolean;
  error?: unknown;
}

export const initialCollectionsState: CollectionsState = {
  collections: [],
  bookmarkCount: null,
  loaded: false,
  error: null,
};

const reducer = createReducer(
  initialCollectionsState,
  on(CollectionsActions.loadCollections, (state) => ({
    ...state,
    error: null,
  })),
  on(CollectionsActions.loadCollectionsSuccess, (state, { collections, bookmarkCount }) => ({
    ...state,
    collections,
    bookmarkCount,
    loaded: true,
    error: null,
  })),
  on(CollectionsActions.loadCollectionsFailure, (state, { error }) => ({
    ...state,
    loaded: true,
    error,
  })),
  // Backend sorts newest first, so a new collection goes to the top
  on(CollectionsActions.createCollectionSuccess, (state, { collection }) => ({
    ...state,
    collections: [{ ...collection, count: 0 }, ...state.collections],
    error: null,
  })),
  on(CollectionsActions.renameCollection, (state, { id, name }) => ({
    ...state,
    collections: state.collections.map((collection) => (collection.id === id ? { ...collection, name } : collection)),
  })),
  on(CollectionsActions.renameCollectionSuccess, (state) => ({
    ...state,
    error: null,
  })),
  // Only roll back if the collection has not been renamed again in the meantime
  on(CollectionsActions.renameCollectionFailure, (state, { id, name, previousName, error }) => ({
    ...state,
    collections: state.collections.map((collection) =>
      collection.id === id && collection.name === name ? { ...collection, name: previousName } : collection,
    ),
    error,
  })),
  on(CollectionsActions.deleteCollectionSuccess, (state, { id }) => ({
    ...state,
    collections: state.collections.filter((collection) => collection.id !== id),
    error: null,
  })),
  on(
    CollectionsActions.createCollectionFailure,
    CollectionsActions.deleteCollectionFailure,
    CollectionsActions.addDocumentsToCollectionFailure,
    CollectionsActions.removeDocumentsFromCollectionsFailure,
    (state, { error }) => ({
      ...state,
      error,
    }),
  ),
);

export function collectionsReducer(state: CollectionsState | undefined, action: Action) {
  return reducer(state, action);
}
